import { ShoppingService } from "../../services/shopping/shopping"

export const getRepurchaseItems = async (activeTabBtn) => {
    try {
        const response = await ShoppingService.callRepurchaseItems(activeTabBtn);
        return response
    } catch (error) {
        return error.message
    }
}

export const addToCart = async (data, activeTab) => {
    try {
        const response = await ShoppingService.callAddToCart(data, activeTab);
        return response
    } catch (error) {
        return error.message
    }
}

export const getCartItems = async (type) => {
    try {
        const response = await ShoppingService.callCartItems(type);
        return response
    } catch (error) {
        return error.message
    }
}

export const decrementCartItem = async (data, activeTab) => {
    try {
        const response = await ShoppingService.callDecrementCartItem(data, activeTab);
        return response
    } catch (error) {
        return error.message
    }
}

export const removeCartItem = async (data, type) => {
    try {
        const response = await ShoppingService.callRemoveCartItem(data, type);
        return response
    } catch (error) {
        return error.message
    }
}

export const addAddress = async (data) => {
    try {
        const response = await ShoppingService.callAddAddress(data);
        return response
    } catch (error) {
        return error.message
    }
}

export const getAddress = async (userId, forUserId) => {
    try {
        const response = await ShoppingService.callAddress(userId, forUserId);
        return response
    } catch (error) {
        return error.message
    }
}

export const callPaymentMethods = async (action) => {
    try {
        const response = await ShoppingService.callPaymentMethods(action);
        return response
    } catch (error) {
        return error.message
    }
}

export const removeAddress = async (data) => {
    try {
        const response = await ShoppingService.callRemoveAddress(data);
        return response
    } catch (error) {
        return error.message
    }
}

export const ProductDetails = async (id, type) => {
    try {
        const response = await ShoppingService.callProductDetails(id, type);
        return response
    } catch (error) {
        console.log(error.message);
    }
}

export const DefaultAddressChange = async (id) => {
    try {
        const response = await ShoppingService.callDefaultAddressChange(id);
        return response
    } catch (error) {
        console.log(error.message);
    }
}

export const PlaceRepurchaseOrder = async (data, type) => {
    try {
        const response = await ShoppingService.callPlaceRepurchaseOrder(data, type);
        return response
    } catch (error) {
        console.log(error.message);
    }
}

export const RepurchaseReport = async (page,limit, sortBy, direction, activeTab) => {
    try {
        const response = await ShoppingService.callRepurchaseReport(page,limit, sortBy, direction, activeTab);
        return response
    } catch (error) {
        console.log(error.message);
    }
}

export const AwardsRewards = async (page,limit, sortBy, direction) => {
    try {
        const response = await ShoppingService.callAwardsRewards(page,limit, sortBy, direction);
        return response
    } catch (error) {
        console.log(error.message);
    }
}

export const RepurchaseInvoice = async(invoiceNo, activeTab) => {
    try {
        const response = await ShoppingService.callPurchaseInvoice(invoiceNo, activeTab);
        return response
    } catch (error) {
        console.log(error.message);       
    }
}

export const CreateReport = async(data) => {
    try {
        const response = await ShoppingService.callCreateReport(data.reportType, data.fileType);
        return response
    } catch (error) {
        console.log(error.message);
    }
}